module.exports = __webpack_public_path__ + "img/selected2-min.1cc3497e.png";